import React from 'react';
import PageContainerAuth from '../../components/common/PageContainerAuth';
import MailingRuleCreateSection from '../../components/pages/mailing-rules/create/MailingRuleCreateSection';

export default function MailingRuleCreate() {
    return (
        <PageContainerAuth section="mailings-add" pageTitle="Nouvelle configuration d'envoi">
            <MailingRuleCreateSection />
        </PageContainerAuth>
    );
}